export default __webpack_public_path__ + "files/nitrate_trend_stations_20_years-0e01603356b01ea93efa17ebba52b596.geojson";